import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import SeoPage from "@/pages/SeoPage";
import CityPage from "@/pages/CityPage";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";
import { seoPages } from "@/data/seoPages";
import { villePages } from "@/data/villePages";
import { legalPages } from "@/data/legalPages";

const ScrollManager = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          if (window.__lenis) {
            window.__lenis.scrollTo(el, { offset: -72 });
          } else {
            el.scrollIntoView({ behavior: "smooth" });
          }
        }
      }, 120);
      return () => clearTimeout(t);
    }
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);
  return null;
};

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          {seoPages.map((p) => (
            <Route key={p.slug} path={`/${p.slug}`} element={<SeoPage page={p} />} />
          ))}
          {legalPages.map((p) => (
            <Route key={p.slug} path={`/${p.slug}`} element={<LegalPage page={p} />} />
          ))}
          {villePages.map((p) => (
            <Route key={p.slug} path={`/${p.slug}`} element={<CityPage page={p} />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
